<template>
  <div class="mb-16 font-normal">
    <h2 class="custom-title custom-color-gray font-medium mb-4">
      {{ $t('message.abm.folders.settings.persistDocument.question') }}
    </h2>
    <p class="custom-legend text-zt-dark-300 mb-4">
      {{ $t('message.abm.folders.settings.persistDocument.description') }}
    </p>
    <div class="w-full radio-group">
      <zt-radio-button
        :value="'true'"
        v-model="selected"
        name="persist"
        @change="update"
        data-vs-radio-button="persist-data"
      >
        <span class="custom-label">{{ $t('message.abm.folders.settings.persistDocument.option.label') }}</span>
      </zt-radio-button>
      <span class="radio-legend block text-zt-dark-300">
        {{ $t('message.abm.folders.settings.persistDocument.option.legend') }}
      </span>
    </div>
    <div class="w-full">
      <zt-radio-button
        :value="'false'"
        v-model="selected"
        name="persist"
        @change="update"
        data-vs-radio-button="update"
      >
        <span class="custom-label">{{ $t('message.abm.folders.settings.persistDocument.option1.label') }}</span>
      </zt-radio-button>
      <span class="radio-legend block text-zt-dark-300">
        {{ $t('message.abm.folders.settings.persistDocument.option1.label') }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PersistDocuments',
  inject: ['stateFolder', 'setParams'],
  data() {
    return {
      selected: ''
    }
  },
  created() {
    this.selected = (!this.stateFolder.params.ephemeral).toString()
  },
  methods: {
    update() {
      /*
        Si selecciona “Si requiere firma” y “Visible”
        Requiere firma = true
        Visible = true
        Efímero = false

        Si selecciona “Si requiere firma” y “Ocultarlos”
        Requiere firma = true
        Visible = true
        Efímero = true
      */
      const ephemeral = (/^(false|0)$/i).test(this.selected) && !!this.selected
      this.setParams({
        ephemeral: ephemeral,
        signature: true,
        visible: true
      })
    }
  }
}
</script>

<style scoped lang="scss">
.custom-color-gray {
  color: #575757;
}
.custom-title {
  font-size: 1.5rem;
}
.custom-legend {
  font-size: 1.125rem;
}
.custom-label {
  font-size: 1.25rem;
  line-height: 1;
  color: #000;
}
.radio-legend {
  margin-left: calc(24px + 1rem);
  line-height: 1;
}
::v-deep {
  .zt-radiobutton {
    label {
      padding-top: 3px;
    }
    i {
      font-size: 1.5rem;
      line-height: 1;
    }
  }
}
</style>